<template>
  <div class="flex text-dark-600">
    <div
      v-clickOutside="close"
      class="flex items-center cursor-pointer -mr-5"
      @click="showDropdown"
    >
      <div v-if="selectedTags.length > 0" class="flex">
        <div
          v-for="tag in selectedTags"
          :key="tag.id"
          class="flex items-center rounded-8 px-7 mr-5 min-w-50 lowercase font-medium"
          :class="tagClass"
          :style="`background-color: #${(tag.color).toString(16)}`"
        >
          <p v-if="tag.name" class="text-12">#</p>
          {{ tag.name }}
        </div>
      </div>

      <div v-else class="text-12 flex items-center rounded-8 px-10 mr-5 bg-grey-500" :class="tagClass">
        <p class="text-14">#</p>
        tag
      </div>
    </div>

    <InfoDropdown v-if="show" title="Tags" class="relative" classes="-right-10 top-25 z-9999" @click.stop>
      <div class="pb-8 px-12 overflow-y-auto">
        <div v-for="tag in tags" :key="tag.id" class="mb-10 flex items-center w-full">
          <Tag :tag="tag" :is-selected="isSelected(tag)" @toggleTag="toggleTag" @updateTag="updateTag" />
        </div>
      </div>
    </InfoDropdown>
  </div>
</template>

<script>
import InfoDropdown from '@/components/shared/InfoDropdown'
import Tag from '@/components/week-planner/Tag'
import { defineComponent, computed, ref } from 'vue'

export default defineComponent({
  components: { InfoDropdown, Tag },

  props: {
    selectedTags: Array,
    tags: Array,
    tagClass: {
      type: String,
      default: 'h-23 text-11'
    }
  },

  emits: ['showDropdown', 'toggleTag', 'updateTag'],

  setup (props, { emit }) {
    const show = ref(false)

    const isSelected = computed(() => tag => props.selectedTags.some(item => item.id === tag.id))

    function showDropdown () {
      show.value = !show.value
    }

    function close () {
      show.value = false
    }

    function toggleTag ({ tag, isSelected }) {
      if (props.selectedTags.length >= 2 && !isSelected) return

      emit('toggleTag', { tag, isSelected })
    }

    function updateTag ({ name, id }) {
      emit('updateTag', { name, id })
    }

    return {
      // data
      show,
      // computeds
      isSelected,
      // functions
      close,
      showDropdown,
      toggleTag,
      updateTag
    }
  }
})
</script>
